import { default as MergeNotice } from "./merge-notice-root";

export default MergeNotice;
